import { render, staticRenderFns } from "./ButtonImgText.vue?vue&type=template&id=9eb1bc16&scoped=true&"
import script from "./ButtonImgText.vue?vue&type=script&lang=js&"
export * from "./ButtonImgText.vue?vue&type=script&lang=js&"
import style0 from "./ButtonImgText.vue?vue&type=style&index=0&id=9eb1bc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb1bc16",
  null
  
)

export default component.exports